export const headerConfig = {
    phoneNumbers: [
        "07.43.59.54.51",
        "06.95.35.11.59"
    ],
    email: "contact@akte-immobilier.com"
};
